import { useLingui } from "@lingui/react/macro";
import { formatCurrency } from "@offstreetparking/design-system/formatters";
import type { SummaryProps } from "../paymentScheduleSummary";
import { DeductionFrequencyRow, FirstDeductionRow } from "./DeductionRows";
import { SummaryRow } from "./SummaryRow";

export const OngoingSummaryRows = ({ overview, locale, currency }: SummaryProps) => {
	const { t } = useLingui();

	return (
		<>
			<SummaryRow
				label={t`Per pay period`}
				value={formatCurrency({ locale, valueInCents: overview.perPeriodAmountInCents, currency })}
			/>
			<DeductionFrequencyRow overview={overview} />
			<FirstDeductionRow overview={overview} />
			<SummaryRow
				label={t({
					message: "Deductions",
					comment: "Row label in the payroll deduction summary; how long the deductions keep going",
				})}
				value={t`Ongoing until your permit is canceled`}
			/>
		</>
	);
};
